type BlogConfig = {
	pageSize?: number;
};

export const getNumberOfBlogs = (displayType: string, blogConfig?: BlogConfig) => {
	switch (displayType) {
		case 'Blog List Page':
		case 'Tag':
			return blogConfig?.pageSize ?? 12;
		case 'One Row':
			return 4;
		case 'Half Screen Left':
		case 'Half Screen Right':
			return 7;
		default:
			return 12;
	}
};
